
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom';
import {baseUrl, limit, formatDate} from "../../comman/config";
import Loader from '../../components/Loader'
import * as XLSX from 'xlsx';
import { DateSessionReportFilter } from "../../components/Filter/DateSessionReportFilter";
import { isFilterActive, matchFilterText, patchFilter } from "../../components/Filter/columnFilter";
import ColumnFilterRow from "../../components/Filter/ColumnFilterRow";
import { ItemName, itemSearchText, itemExportName } from "../../components/ItemName";

// One definition per column, driving the header, the inline filter row, the body and the export --
// so a column can never read one way in the table and another in the filter above it. A column adds
// `render` / `exportText` when the cell or the file needs something other than `text`: Menu Item
// reads in Gujarati, is searched in either language, and is written out in both (components/ItemName).
const COLUMNS = [
    { key: 'date',        label: 'Date',                          text: (r) => formatDate(r.date) },
    { key: 'session',     label: 'Session',                       text: (r) => r.session_name ?? '' },
    { key: 'menu_item',   label: 'Menu Item',                     text: itemSearchText,
      render: (r) => <ItemName item={r} />, exportText: itemExportName },
    { key: 'raw_qty',     label: 'Actual Raw Qty.',               text: (r) => r.batch_raw_material_qty },
    { key: 'finished',    label: 'Finished Qty',                  text: (r) => r.roti_finished_qty ?? 0 },
    { key: 'total_rotis', label: 'Total no. Rotis',               text: (r) => r.finishedQty ?? 0 },
    { key: 'rm_to_fg',    label: 'RM to FG Ratio (Multiplier)',   text: (r) => r.batch_raw_material_qty > 0 ? (r.roti_finished_qty / r.batch_raw_material_qty).toFixed(3) : 0 },
    { key: 'gulla',       label: 'Gulla weight',                  text: (r) => r.gulla_weight },
    { key: 'avg_roti',    label: 'Avg. weight of 1 finished roti', text: (r) => r.avg_weight_of_1_finished_roti ?? 0 },
    { key: 'rotis_box',   label: 'No of rotis in 1  icebox',      text: (r) => r.nos_of_rotis_1_icebox ?? 0 },
    { key: 'iceboxes',    label: 'No. of Icebox',                 text: (r) => r.no_of_actual_bowls },
    { key: 'rm_roti',     label: 'RM to No.of Roti Ratio',        text: (r) => r.current_rm_to_fg_ratio ?? 0 },
    { key: 'rm_icebox',   label: 'RM to No.of icebox Ratio',      text: (r) => r.current_rm_to_bowl_ratio },
];

function List() {

    const today = new Date().toISOString().split("T")[0];    
    const [filteredList, setFilteredList] = useState([]);
    const [reportList, setReportList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [session, setSession] = useState("");
    const [item, setItem] = useState("");
    const [method, setMethod] = useState("");
    const [summary, setSummary] = useState(true);
    const [reportType, setReportType] = useState(1);
    const [loading, setLoading] = useState(false)
    // Inline per-column filters: { [colKey]: { op, v1, v2 } }, matched against the cell's own text.
    const [filters, setFilters] = useState({});
    const setColFilter = (key, patch) => setFilters(prev => patchFilter(prev, key, patch));
    const activeFilterCols = COLUMNS.filter(c => isFilterActive(filters[c.key]));
    const visibleRows = filteredList.filter(r => activeFilterCols.every(c => matchFilterText(c.text(r), filters[c.key])));

    useEffect(() => {
        
            getShortageList(); 
        
    }, [fromDate,toDate, session, item, method]);


    useEffect(() => {
        let filterelist;
        if(method && method.length > 0){
            const methodIds = method.map(method => method.value);
            filterelist = reportList.filter((item) => methodIds.includes(item.measurements));
        } else{
            filterelist = reportList;
        }  
        setFilteredList(filterelist);
    }, [ method, reportList]);
    const getShortageList = async () => {
        
        setPopupOpen(true);
        setLoading(true)
        const response = await axios.get(`${baseUrl}/reports/master_report?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}&session=${encodeURIComponent(JSON.stringify(session))}&item=${encodeURIComponent(JSON.stringify(item))}&method=${encodeURIComponent(JSON.stringify(method))}`, {
           
        });
        console.log(response.data.data)
        setLoading(false)
        setPopupOpen(false);
        setReportList(response.data.data);
        setFilteredList(response.data.data);
        setTotalItem(response.data.totalItem);
    }

    const handelFilterChange= (fromDate, toDate, session, item, method) => {
        console.log(item);
        setFromDate(fromDate);
        setToDate(toDate);
        setSession(session);
        setItem(item);
        setMethod(method);
        
        
    };

    // const hadelSummary = (summary) => {
    //     setSummary(summary);
    // }

    const handelReportChange = (data) => {
        console.log(data);
        setReportType(data.value);
    }
   
    // Exports what the table shows -- the inline filters narrow the file too.
    const handleExport = () => {
        const header = COLUMNS.map(c => c.label);
        const data = visibleRows.map((item) => COLUMNS.map(c => (c.exportText ? c.exportText(item) : c.text(item))));

        const worksheet = XLSX.utils.aoa_to_sheet([header, ...data]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Rotli Bhakhri Production Report");

        XLSX.writeFile(workbook, `Rotli_Bhakhri_Prod_Report_${fromDate ? '_' + formatDate(fromDate) : ''}to${toDate ? '_' + formatDate(toDate) : ''}${session?.label ? '_' + session.label : ''}.xlsx`);
    }
    
   
      


    return (
        <div className="p-4">
            {loading && <Loader/>}
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-2xl font-bold">Rotli / Bhakhri Production Report</h1>
                <div>
                    <Link to="/">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Back</button>
                    </Link>
                </div>
            </div>
            <div className="relative shadow-md sm:rounded-lg">
            <DateSessionReportFilter 
            handleFilterChange={handelFilterChange} 
            // hadelSummary={hadelSummary} 
            handleExport={handleExport}
            handelReportChange={handelReportChange} 
            handleClearFilters={() => setFilters({})}
    
            />


                <div className="overflow-x-auto">
                <table className="w-full  text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            {COLUMNS.map(c => (
                                <th key={c.key} scope="col" className="px-2 py-1 border border-black text-center">{c.label}</th>
                            ))}
                        </tr>
                        {/* Inline per-column filter row (contains / = / ≤ / ≥ / between / not between) */}
                        <ColumnFilterRow
                            thClassName="px-1 py-1 border border-black bg-gray-50 dark:bg-gray-700 align-top"
                            cols={COLUMNS.map(c => ({ key: c.key }))}
                            filters={filters}
                            onChange={setColFilter} />
                    </thead>
                    <tbody>
                    {visibleRows.map((item, index) => (
                        <tr key={index} className={`${(item.methodName?.id == 1 ? 'bg-blue-200' : (item.methodName?.id == 2 ? 'bg-orange-200' : 'bg-lime-200 '))} border border-black-b`}>
                            {COLUMNS.map(c => (
                                <td key={c.key} className="px-2 py-1 border border-black text-center">{c.render ? c.render(item) : c.text(item)}</td>
                            ))}
                        </tr>))}
                    {!loading && visibleRows.length === 0 && (
                        <tr><td className="px-2 py-4 text-center text-gray-500" colSpan={COLUMNS.length}>
                            {activeFilterCols.length ? 'No rows match the filters.' : 'No records found.'}
                        </td></tr>
                    )}
                    </tbody>
                </table>
                </div>
            </div>
        </div>
  );
}

export default List;